import MainLanding from './MainLanding';

export default MainLanding;
